import TalkToSalesButton from 'pricing-pages-ui/components/common/purchaseMotions/TalkToSalesButton';
import { getFirstHubSkuIdFromProductConfigurations } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { useSelector } from 'react-redux';
import DTBButton from '../../../components/common/purchaseMotions/DTBButton';
import DTTButton from '../../../components/common/purchaseMotions/DTTButton';
import { productForSkuIdSelector } from '../../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
/*
  This component fully encapsulates purchase motion logic
  for the public site.
*/
const PublicPurchaseMotionButton = props => {
  const {
    productConfigurations,
    purchaseMotion,
    hubsSignupProductOverride,
    nonMerchandiseIdProduct,
    trackingSource,
    use
  } = props;
  const firstHubSkuId = useSelector(state => getFirstHubSkuIdFromProductConfigurations(state, {
    productConfigurations
  }));
  const firstNonHubSkuId = productConfigurations && productConfigurations.length && productConfigurations[0].skuId;
  const apiName = useSelector(state => {
    if (!firstHubSkuId) return null;
    const product = productForSkuIdSelector(state, {
      skuId: firstHubSkuId
    });
    return product && product.apiName;
  });
  const productIdentifier = hubsSignupProductOverride || nonMerchandiseIdProduct || (apiName === null || apiName === void 0 ? void 0 : apiName.toString());
  switch (purchaseMotion) {
    case 'BUY_TOUCHLESS':
      return /*#__PURE__*/_jsx(DTBButton, Object.assign({}, props, {
        productIdentifier: productIdentifier,
        use: use !== null && use !== void 0 ? use : 'primary'
      }));
    case 'TRIAL':
      return firstHubSkuId ? /*#__PURE__*/_jsx(DTTButton, Object.assign({}, props, {
        skuId: firstHubSkuId,
        upgradeSource: trackingSource,
        use: use !== null && use !== void 0 ? use : 'primary'
      })) : null;
    default:
      return /*#__PURE__*/_jsx(TalkToSalesButton, Object.assign({
        skuId: firstHubSkuId || firstNonHubSkuId,
        productIdentifier: productIdentifier
      }, props, {
        use: use !== null && use !== void 0 ? use : 'primary'
      }));
  }
};
export default PublicPurchaseMotionButton;